import { I18n } from 'utils/i18n';

export default function toolNameConflictMessage(err) {
  if (err?.status === 409) {
    return I18n.t('AgenticChatFlow.ToolNameInUse');
  }
  return I18n.t('AgenticChatFlow.ToolSaveError');
}
